import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import UpcomingEventsPopup from './components/UpcomingEventsPopup';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Events from './pages/Events';
import Contact from './pages/Contact';
import { ConfirmRegistration, ManageRegistration } from './pages/Registration';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <UpcomingEventsPopup />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/anmeldung/bestaetigen/:token" element={<ConfirmRegistration />} />
            <Route path="/anmeldung/:token" element={<ManageRegistration />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;
